export const EXPORT_STORAGE_BUCKET_CONFIG = 'EXPORT_STORAGE_BUCKET';
export const EXPORT_STORAGE_MODE_CONFIG = 'EXPORT_STORAGE_MODE';
export const EXPORT_LOCAL_DIR_CONFIG = 'EXPORT_LOCAL_DIR';
export const EXPORT_STORAGE_SERVICE = 'EXPORT_STORAGE_SERVICE';
export const exportStorageModes = ['s3', 'filesystem'] as const;
export type TExportStorageMode = (typeof exportStorageModes)[number];
export const Statuses = ['STARTING', 'COMPLETED', 'PROCESSED'] as const;
export type TStatus = (typeof Statuses)[number];
export const valueModes = ['analysedCount', 'meanPerSample'] as const;
export type TValueMode = (typeof valueModes)[number];
export const valueModeLabelMap: Record<TValueMode, string> = {
  analysedCount: 'Analysed count',
  meanPerSample: 'Mean per sample',
} as const;
export const valueModeLabelList = Object.entries(valueModeLabelMap);

export const plussedValuesExportModes = ['plus', 'ten-to-minus-ten'] as const;
export type TPlussedValuesExportMode = (typeof plussedValuesExportModes)[number];
export const defaultPlussedValuesExportMode: TPlussedValuesExportMode = 'ten-to-minus-ten';
export const plussedValuesExportModeLabelMap: Record<TPlussedValuesExportMode, string> = {
  plus: 'Export as plus (+)',
  'ten-to-minus-ten': 'Export as 10^-10',
} as const;
export const plussedValuesExportModeLabelList = Object.entries(plussedValuesExportModeLabelMap);
